"use client";

import React from "react";
import {ArticlesCategoryCount} from "@/common/entities/articles/Article";
import styles from "../../Blog/blog.module.scss";
import {Form} from "react-bootstrap";

interface ArticlesCategoriesFilterProps {
    onCategoriesFilter: (categoryId: number) => void;
    filters: { [key: string]: string | undefined };
    data: ArticlesCategoryCount[] | undefined;
}

const ArticlesCategoriesFilter = ({onCategoriesFilter, filters, data}: ArticlesCategoriesFilterProps) => {
    const isCategoryChecked = (categoryId: number) => filters.categoriesIds?.split(",").includes(categoryId.toString()) || false;

    return (
        <div className={styles.sideBarCard}>
            <h3 className={styles.titleCategories}>Categorii</h3>
            <ul className={styles.categoryList}>
                {(data || []).map(({categoryId, categoryName, count}, index) => (
                    <li key={index}>
                        <div className="d-flex justify-content-between align-items-center">
                            <Form.Check
                                type="checkbox"
                                label={categoryName}
                                id={`${categoryName}-${index}`}
                                onChange={() => onCategoriesFilter(categoryId)}
                                checked={isCategoryChecked(categoryId)}
                            />
                            <small className="text-secondary">({count})</small>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ArticlesCategoriesFilter;
